document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-file-upload]').forEach(function (wrapper) {
        const input = wrapper.querySelector('[data-file-input]');
        const placeholder = wrapper.querySelector('[data-upload-placeholder]');
        const preview = wrapper.querySelector('[data-file-preview]');
        const thumb = wrapper.querySelector('[data-file-thumb]');
        const nameEl = wrapper.querySelector('[data-file-name]');
        const removeBtn = wrapper.querySelector('[data-file-remove]'); 
        input.addEventListener('change', function () {
        const file = input.files[0];
        if (!file) return; 
        nameEl.textContent = file.name; 
        // Show image thumbnail if it's an image, otherwise show file extension
        if (file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = function (e) {
            thumb.style.backgroundImage = `url(${e.target.result})`;
            thumb.textContent = '';
            };
            reader.readAsDataURL(file);
        } else {
            thumb.style.backgroundImage = '';
            const ext = file.name.split('.').pop().toUpperCase();
            thumb.textContent = ext;
        } 
        placeholder.hidden = true;
        preview.hidden = false;
        }); 
        removeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        input.value = '';
        thumb.style.backgroundImage = '';
        thumb.textContent = '';
        nameEl.textContent = '';
        preview.hidden = true;
        placeholder.hidden = false;
        });
    });
}); 

// Ensures Shopify's native file line-item-property upload works correctly on Dawn.
//
// Why this is needed:
// Dawn's Add to Cart flow (and possibly other theme/app scripts) intercept the
// form's submit and read field values via JS (for AJAX cart rendering). When a
// <input type="file"> value is read as text instead of as a real File object,
// the browser reports a fake placeholder path like "C:\fakepath\image.webp"
// instead of uploading the actual file.
//
// Fix: when a file is selected, instead of trying to fight every script that
// might touch the existing form/button, we build a brand new, plain <form>
// element on the fly (one that no other script has ever attached a listener
// to), move the real file input + a copy of the needed fields into it, and
// submit it natively. This guarantees nothing else can intercept it.
document.addEventListener(
  'click',
  function (event) {
    const button = event.target.closest('button[type="submit"], input[type="submit"]');
    if (!button) return;

    const originalForm = button.closest('form[data-type="add-to-cart-form"]');
    if (!originalForm) return;

    const fileInput = originalForm.querySelector('input[type="file"]');
    if (!fileInput || fileInput.files.length === 0) return; // no file selected, let Dawn handle it normally

    // Block this click completely — stop it from reaching Dawn's (or any
    // other) click/submit handlers.
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    // Figure out the correct cart add endpoint.
    const actionUrl = originalForm.getAttribute('action') || '/cart/add';

    // Build a brand new form — no other script has ever seen this element,
    // so nothing can hijack its submission.
    const nativeForm = document.createElement('form');
    nativeForm.method = 'post';
    nativeForm.action = actionUrl;
    nativeForm.enctype = 'multipart/form-data';
    nativeForm.style.display = 'none';

    // Copy every relevant field from the visible form, EXCEPT the file input
    // (which we move, not clone, so the actual selected file is preserved).
    originalForm.querySelectorAll('input, select, textarea').forEach((field) => {
      if (field === fileInput) return;
      if (!field.name) return;
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;

      const clone = document.createElement('input');
      clone.type = 'hidden';
      clone.name = field.name;
      clone.value = field.value;
      nativeForm.appendChild(clone);
    });

    // Move the real file input (preserves the selected File object).
    nativeForm.appendChild(fileInput);

    document.body.appendChild(nativeForm);
    nativeForm.submit();
  },
  true // capture phase: runs before any other click listener
);